const TYPES = {
    SEARCH_USERS: 'SEARCH_USERS',
    SEARCH_USERS_RESULTS: 'SEARCH_USERS_RESULTS'
};

const searchUsers = (searchText) => ({
    type: TYPES.SEARCH_USERS, searchText
});

export {
    TYPES,
    searchUsers,
};
